import { createSlice, nanoid } from "@reduxjs/toolkit";
import { logout } from "../../auth/authSlice";

const initialState = { data: null, request: null, status: "idle", error: null };

const sensorHeatmapSlice = createSlice({
  name: "sensorHeatmap",
  initialState,
  reducers: {
    fetchSensorHeatmapStart: {
      prepare: (payload) => ({ payload: { ...payload, requestId: nanoid() } }),
      reducer(state, action) {
        state.request = action.payload;
        state.data = null;
        state.status = "loading";
        state.error = null;
      },
    },
    fetchSensorHeatmapSuccess(state, action) {
      if (state.request?.requestId !== action.payload.requestId) return;
      state.data = {
        ...action.payload.data,
        requestId: action.payload.requestId,
      };
      state.status = "ready";
      state.error = null;
    },
    fetchSensorHeatmapFailure(state, action) {
      if (state.request?.requestId !== action.payload.requestId) return;
      state.data = null;
      state.status = action.payload.isEmpty ? "empty" : "error";
      state.error = action.payload.error;
    },
    resetSensorHeatmapState: () => initialState,
  },
  extraReducers: (builder) => builder.addCase(logout, () => initialState),
});

export const {
  fetchSensorHeatmapStart,
  fetchSensorHeatmapSuccess,
  fetchSensorHeatmapFailure,
  resetSensorHeatmapState,
} = sensorHeatmapSlice.actions;
export default sensorHeatmapSlice.reducer;
